export default __webpack_public_path__ + "static/media/SFONDO-NFT-NOT-FOUND-MOBILE.77bbdc5e.png";